import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const DEFAULT_CIRCLE_LINK = {
  loading: false,
  hasCircle: false,
  to: '/create-circle',
  label: '団体募集',
};

function useMyCircleLink(currentUser) {
  const [circleLink, setCircleLink] = useState(DEFAULT_CIRCLE_LINK);
  const location = useLocation();

  useEffect(() => {
    let active = true;

    async function loadCircle() {
      if (!currentUser?.uid) {
        setCircleLink(DEFAULT_CIRCLE_LINK);
        return;
      }

      setCircleLink((prev) => ({ ...prev, loading: true }));

      try {
        const snap = await getDocs(query(
          collection(db, 'recruitments'),
          where('userId', '==', currentUser.uid),
          where('recruitmentType', '==', 'group'),
          where('status', 'in', ['active', 'closed']),
          limit(1)
        ));

        if (!active) return;

        if (snap.empty) {
          setCircleLink(DEFAULT_CIRCLE_LINK);
          return;
        }

        setCircleLink({
          loading: false,
          hasCircle: true,
          to: `/circles/${snap.docs[0].id}/manage`,
          label: '団体・サークル管理',
        });
      } catch (error) {
        console.error('Failed to load my circle link:', error);
        if (active) {
          setCircleLink(DEFAULT_CIRCLE_LINK);
        }
      }
    }

    loadCircle();
    return () => { active = false; };
  }, [currentUser, location.key]);

  return circleLink;
}

export default useMyCircleLink;
